import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
import formatData from "../utils/formatData";
const bqGetReportChallengeData = async function (compettionId, startDate, endDate) {
    const app = firebase.app();
    const functions = getFunctions(app, 'asia-east2');
    const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');



    const result = await Promise.all([

        //0:get member number
        queryThaisookViewBigQuery({
            info: 'get group member',
            query: `
                WITH data as (
                    SELECT 
                        CU.groupId,
                        CU.startBMI
                    FROM 
                        thaisook_view.competition C
                        join thaisook_view.competition_users CU
                            on C.competitionId = CU.competitionId
                    WHERE
                        C.competitionId = '${compettionId}'
                )
                SELECT (CASE WHEN startBMI < 26 then 'bmi<25'
                            WHEN startBMI > 25 THEN 'bmi>25'
                        END) as bmiCnt, groupId,
                        COUNT(*) as cnt
                FROM data
                GROUP BY bmiCnt, groupId
                order by groupId
            `
        }),

        //1:get healthpoint
        queryThaisookViewBigQuery({
            info: 'get group healthpoint',
            query: `
            CREATE TEMP FUNCTION totalHealthpoint(food numeric,water numeric, sleep numeric, other numeric, workout numeric, step numeric,date_str string)
            RETURNS numeric
            LANGUAGE js
            AS r"""
              var date = new Date(date_str);
              var sum =0;
              var totalWorkout = workout + step;
              if(totalWorkout > 5 ) totalWorkout = 5;
              if(food > 5) food = 5;
              if(sleep > 2) sleep = 2;
              if(water > 0) other = 1;
              if(other > 1) other = 1;
              if(date <= new Date('2025-07-23')) {
                sum = totalWorkout + food + sleep + other;
              } else {
                other = other + sleep + water;
                if(other > 1) other = 1;
                sum = totalWorkout + food + other;
              }
              
              if (sum > 10) sum = 10;
              return sum;
            """;
                with data as (
                SELECT 
                    CU.groupId,
                    HP.date,
                    HP.uid,
                    totalHealthpoint(HP.foodScore, HP.waterScore, HP.sleepScore, HP.otherScore, HP.workoutScore, HP.stepScore, cast(HP.date as string)) as healthPoint
                FROM 
                    thaisook_view.competition C
                    join thaisook_view.competition_users CU
                    on C.competitionId = CU.competitionId
                    join thaisook_view.healthpoint HP
                    on HP.uid = CU.uid 
                    and date(HP.date) between date('${startDate}') and date('${endDate}')
                WHERE
                    C.competitionId = '${compettionId}'
                    and date(HP.date) >= date(CU.startWeightDate)
                )
                select groupId, sum(healthPoint) totalHealthpoint from data group by groupId;
            `
        }),

        //2:get weight bmi
        queryThaisookViewBigQuery({
            info: 'get group bmi weight',
            // query2: `
            //     SELECT 
            //         CU.groupId,
            //         sum(IF( (currentWeight > startWeight), 0, (currentWeight - startWeight) )) as totalWeightLoss,
            //         sum(IF( (currentBMI > startBMI), 0, (currentBMI - startBMI) )) as totalBMIChanges
            //     FROM 
            //         thaisook_view.competition C
            //         join thaisook_view.competition_users CU
            //             on C.competitionId = CU.competitionId
            //         WHERE
            //         C.competitionId = '${compettionId}'
            //         and CU.startBMI > 23 
            //         group by CU.groupId
            // `,
            query: `
                with data as (
                    SELECT 
                        G.groupId,
                        HD.uid,
                        HD.date,
                        HD.weight,
                        FIRST_VALUE(HD.weight) OVER(PARTITION BY HD.uid ORDER BY date) AS start_weight,
                        LAST_VALUE(HD.weight) OVER(PARTITION BY HD.uid ORDER BY date desc) AS end_weight,
                        ROW_NUMBER() OVER(PARTITION BY HD.uid ORDER BY date DESC) AS last_record
                    FROM 
                        thaisook_view.healthdata HD
                        join thaisook_view.competition_users G
                        on G.uid = HD.uid 
                    where 
                        HD.weight is not null
                        and G.competitionId = '${compettionId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                        and date(HD.date) >= date(G.startWeightDate)
                        order by HD.date
                )
                , data2 as (
                    select * from data where last_record = 1
                )
                select 
                    groupId,
                    sum(end_weight - start_weight) as totalWeightLoss
                from 
                    data2 
                group by 
                    groupId;
            `
        }),

        //3:get workout distance, serving
        queryThaisookViewBigQuery({
            info: 'get group workout distanct serving',
            query: `
                SELECT 
                    CA.groupId,
                    sum(CA.totalWorkout) as totalWorkout,
                    sum(case when CA.activityType = 'run' then CA.distance else 0 end) as totalDistance,
                    sum(CA.serving) as totalServing

                FROM 
                    thaisook_view.competition C
                    join activity_view.competition_activities CA 
                        on C.competitionId = CA.competitionId
                        and date(CA.date) between date('${startDate}') and date('${endDate}')
                    join thaisook_view.competition_users CU
                        on CU.uid = CA.uid 
                        and CU.competitionId = C.competitionId
                    WHERE
                    C.competitionId = '${compettionId}'
                    and date(CA.date) >= date(CU.startWeightDate)
                    and CA.reportFlag = false
                    group by CA.groupId
            `
        }),

        //4:get steps
        queryThaisookViewBigQuery({
            info: 'get group steps',
            query: `
                SELECT 
                    CU.groupId,
                    sum(case when WO.steps > C.maxStepsPerDay THEN C.maxStepsPerDay ELSE WO.steps END) as totalSteps
                FROM 
                    thaisook_view.competition C
                    join thaisook_view.competition_users CU
                        on C.competitionId = CU.competitionId
                    join activity_view.workout WO
                        on WO.uid = CU.uid 
                        and date(WO.date) between date('${startDate}') and date('${endDate}')
                    WHERE
                    C.competitionId = '${compettionId}'
                    and date(WO.date) >= date(CU.startWeightDate)
                    group by CU.groupId
            `
        }),

        //5:get total workout number
        queryThaisookViewBigQuery({
            info: 'get group total workout',
            query: `
                SELECT 
                    CA.groupId,
                    count(1) as totalWorkoutNumber
                FROM 
                    thaisook_view.competition C
                    join activity_view.competition_activities CA 
                    on C.competitionId = CA.competitionId
                    and date(CA.date) between date('${startDate}') and date('${endDate}')
                    join thaisook_view.competition_users CU
                        on CU.uid = CA.uid 
                        and CU.competitionId = C.competitionId
                WHERE
                    C.competitionId = '${compettionId}'
                    and CA.reportFlag = false
                    and CA.totalWorkout > 0
                    and date(CA.date) >= date(CU.startWeightDate)
                    group by CA.groupId
            `
        }),

        //6:get group data
        queryThaisookViewBigQuery({
            info: 'get group info',
            query: `
                SELECT 
                    distinct
                    CU.groupId,
                    g.name
                FROM 
                    thaisook_view.competition C
                        join thaisook_view.competition_users CU
                            on C.competitionId = CU.competitionId
                        join thaisook_view.groups G
                            on G.groupId = CU.groupId
                WHERE
                    C.competitionId = '${compettionId}'
                `
        }),

        // //7:get meditation
        // queryThaisookViewBigQuery({
        //     info: 'get group meditation',
        //     query: `
        //         SELECT 
        //             CU.groupId,
        //             sum(WO.meditation) as totalMeditation
        //         FROM 
        //             thaisook_view.competition C
        //             join thaisook_view.competition_users CU
        //                 on C.competitionId = CU.competitionId
        //             join activity_view.workout WO
        //                 on WO.uid = CU.uid 
        //                 and date(WO.date) between date('${startDate}') and date('${endDate}')
        //             WHERE
        //             C.competitionId = '${compettionId}'
        //             and date(WO.date) >= date(CU.startWeightDate)
        //             group by CU.groupId
        //     `
        // }),

        //8:get bmi
        queryThaisookViewBigQuery({
            info: 'get group bmi',
            query: `
                with data as (
                    SELECT 
                        G.groupId,
                        HD.uid,
                        HD.date,
                        HD.bmi,
                        FIRST_VALUE(HD.bmi) OVER(PARTITION BY HD.uid ORDER BY date) AS start_bmi,
                        LAST_VALUE(HD.bmi) OVER(PARTITION BY HD.uid ORDER BY date desc) AS end_bmi,
                        ROW_NUMBER() OVER(PARTITION BY HD.uid ORDER BY date DESC) AS last_record
                    FROM 
                        thaisook_view.healthdata HD
                        join thaisook_view.competition_users G
                        on G.uid = HD.uid 
                    where 
                        HD.weight is not null
                        and G.competitionId = '${compettionId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                        and date(HD.date) >= date(G.startWeightDate)
                        order by HD.date
                )
                , data2 as (
                    select * from data where last_record = 1
                )
                select 
                    groupId,
                    sum(end_bmi - start_bmi) as totalBMIChanges 
                from 
                    data2 
                group by groupId;
            `
        })
    ]);

    const groupMemberObj = JSON.parse(result[0].data);
    let groupMemberHash = [];
    if (groupMemberObj.length) {
        groupMemberHash = groupMemberObj.reduce((tmp, doc) => {
            if (tmp[doc.groupId] == undefined) {
                tmp[doc.groupId] = {
                    total: 0,
                    'bmi>25': 0,
                    'bmi<25': 0,
                };
            }
            tmp[doc.groupId][doc['bmiCnt']] = tmp[doc.groupId][doc['bmiCnt']] + doc['cnt']
            tmp[doc.groupId]['total'] = tmp[doc.groupId]['total'] + doc['cnt']

            return tmp;
        }, {});

        // console.log('groupMemberHash', groupMemberHash);
    }
    const groupHealPointObj = JSON.parse(result[1].data);
    let groupHealthPointHash = [];
    if (groupHealPointObj.length) {
        groupHealthPointHash = groupHealPointObj.reduce((tmp, doc) => {
            tmp[doc.groupId] = doc;
            return tmp;
        }, {});

        // console.log('groupHealthPointHash', groupHealthPointHash);
    }


    const groupWeightObj = JSON.parse(result[2].data);
    let groupWeightHash = [];
    if (groupWeightObj.length) {
        groupWeightHash = groupWeightObj.reduce((tmp, doc) => {
            tmp[doc.groupId] = doc;
            return tmp;
        }, {});

        // console.log('groupWeightHash', groupWeightHash);
    }

    const groupBMIObj = JSON.parse(result[7].data);
    let groupBMIHash = [];
    if (groupBMIObj.length) {
        groupBMIHash = groupBMIObj.reduce((tmp, doc) => {
            tmp[doc.groupId] = doc;
            return tmp;
        }, {});

        // console.log('groupBMIHash', groupBMIHash);
    }

    const groupActivityObj = JSON.parse(result[3].data);
    let groupActivityHash = [];
    if (groupActivityObj.length) {
        groupActivityHash = groupActivityObj.reduce((tmp, doc) => {
            tmp[doc.groupId] = doc;
            return tmp;
        }, {});

        // console.log('groupActivityHash', groupActivityHash);
    }
    const groupStepsObj = JSON.parse(result[4].data);
    let groupStepsHash = [];
    if (groupStepsObj.length) {
        groupStepsHash = groupStepsObj.reduce((tmp, doc) => {
            tmp[doc.groupId] = doc;
            return tmp;
        }, {});

        // console.log('groupStepsHash', groupStepsHash);
    }

    const groupTotalWorkoutNumberObj = JSON.parse(result[5].data);
    let groupTotalWorkoutNumberHash = [];
    if (groupTotalWorkoutNumberObj.length) {
        groupTotalWorkoutNumberHash = groupTotalWorkoutNumberObj.reduce((tmp, doc) => {
            tmp[doc.groupId] = doc;
            return tmp;
        }, {});

        // console.log('groupTotalWorkoutNumberHash', groupTotalWorkoutNumberHash);
    }

    // const groupTotalMeditationObj = JSON.parse(result[7].data);
    // let groupTotalMeditationHash = [];
    // if( groupTotalMeditationObj.length ){
    //     groupTotalMeditationHash = groupTotalMeditationObj.reduce((tmp, doc) => {
    //         tmp[doc.groupId] = doc;
    //         return tmp;
    //     }, {});

    //     // console.log('groupTotalMeditationHash', groupTotalMeditationHash);
    // }

    const groupInfoObj = JSON.parse(result[6].data);
    if (groupInfoObj.length) {
        Object.entries(groupInfoObj).forEach(entry => {
            // console.log(reportRow);
            // const [key, row ] = entry;
            const reportRow = entry[1];
            // console.log(key, reportRow);
            reportRow['id'] = reportRow.groupId;
            reportRow['name'] = reportRow.name + " (" + reportRow.groupId + ")";
            reportRow['members'] = groupMemberHash[reportRow.groupId]['total'];


            reportRow['weight_loss_total'] = 0;
            reportRow['weight_loss'] = 0;
            reportRow['bmi_changes_total'] = 0;
            reportRow['bmi_changes'] = 0;
            reportRow['bmi_changes_percent'] = 0;
            if (groupWeightHash[reportRow.groupId] != undefined && reportRow['members']) {
                reportRow['weight_loss_total'] = groupWeightHash[reportRow.groupId]['totalWeightLoss'];
                reportRow['weight_loss'] = groupWeightHash[reportRow.groupId]['totalWeightLoss'] / reportRow['members'];
                reportRow['weight_loss_percent'] = (reportRow['weight_loss'] / reportRow['members']) * 100;
                reportRow['bmi_changes_total'] = groupBMIHash[reportRow.groupId]['totalBMIChanges'];
                reportRow['bmi_changes'] = groupBMIHash[reportRow.groupId]['totalBMIChanges'] / reportRow['members'];
            }
            if (reportRow['weight_loss_total'] > 0) {
                // reportRow['weight_loss_total'] = formatData('average', reportRow['weight_loss_total'] );
                reportRow['weight_loss'] = reportRow['weight_loss_total'] + ' (' + formatData('average', reportRow['weight_loss']) + ')';
            }
            else {
                reportRow['weight_loss_total'] = '';
                reportRow['weight_loss'] = '';
            }
            if (reportRow['weight_loss_percent'] > 0) {
                reportRow['weight_loss_percent'] = formatData('average', reportRow['weight_loss_percent']);
            }
            else {
                reportRow['weight_loss_percent'] = '';
            }
            if (reportRow['bmi_changes_total'] > 0) {
                // reportRow['bmi_changes_total'] = formatData('average', reportRow['bmi_changes_total'] );
                reportRow['bmi_changes'] = reportRow['bmi_changes_total'] + ' (' + formatData('average', reportRow['bmi_changes']) + ')';
            }
            else {
                reportRow['bmi_changes_total'] = '';
                reportRow['bmi_changes'] = '';
            }
            reportRow['healthpoints_total'] = 0;
            reportRow['healthpoints_av'] = 0;
            if (groupHealthPointHash[reportRow.groupId] != undefined) {
                reportRow['healthpoints_total'] = groupHealthPointHash[reportRow.groupId]['totalHealthpoint'];
                reportRow['healthpoints_av'] = groupHealthPointHash[reportRow.groupId]['totalHealthpoint'] / reportRow['members'];
            }
            if (reportRow['healthpoints_total'] > 0) {
                reportRow['healthpoints_av'] = reportRow['healthpoints_total'] + ' (' + formatData('average', reportRow['healthpoints_av']) + ')';
            }
            else {
                reportRow['healthpoints_av'] = '';
            }


            reportRow['servings_av'] = 0;
            reportRow['servings_total'] = 0;

            reportRow['workout_minutes_av'] = 0;
            reportRow['workout_minutes_total'] = 0;

            reportRow['distance_av'] = 0;
            reportRow['distance_total'] = 0;
            if (groupActivityHash[reportRow.groupId] != undefined) {
                reportRow['servings_total'] = groupActivityHash[reportRow.groupId]['totalServing'] || 0;
                reportRow['servings_av'] = groupActivityHash[reportRow.groupId]['totalServing'] / reportRow['members'];
                reportRow['workout_minutes_total'] = groupActivityHash[reportRow.groupId]['totalWorkout'] || 0;
                reportRow['workout_minutes_av'] = groupActivityHash[reportRow.groupId]['totalWorkout'] / reportRow['members'];
                reportRow['distance_total'] = groupActivityHash[reportRow.groupId]['totalDistance'] || 0;
                reportRow['distance_av'] = groupActivityHash[reportRow.groupId]['totalDistance'] / reportRow['members'];
            }
            if (reportRow['servings_total'] > 0) {
                reportRow['servings_av'] = reportRow['servings_total'] + ' (' + formatData('average', reportRow['servings_av']) + ')';
            }
            else {
                reportRow['servings_av'] = '';
            }
            if (reportRow['workout_minutes_total'] > 0) {
                reportRow['workout_minutes_av'] = reportRow['workout_minutes_total'] + ' (' + formatData('average', reportRow['workout_minutes_av']) + ')';
            }
            else {
                reportRow['workout_minutes_av'] = '';
            }
            if (reportRow['distance_total'] > 0) {
                reportRow['distance_av'] = reportRow['distance_total'] + ' (' + formatData('average', reportRow['distance_av']) + ')';
            }
            else {
                reportRow['distance_av'] = '';
            }

            reportRow['steps_av'] = 0;
            reportRow['steps_total'] = 0;
            if (groupStepsHash[reportRow.groupId] != undefined) {
                reportRow['steps_av'] = groupStepsHash[reportRow.groupId]['totalSteps'] / reportRow['members'];
                reportRow['steps_total'] = groupStepsHash[reportRow.groupId]['totalSteps'];
            }
            if (reportRow['steps_total'] > 0) {
                reportRow['steps_av'] = reportRow['steps_total'] + ' (' + formatData('average', reportRow['steps_av']) + ')';
            }
            else {
                reportRow['steps_av'] = '';
            }

            // reportRow['meditation_av'] = 0;
            // if( groupTotalMeditationHash[reportRow.groupId] != undefined ){
            //     reportRow['meditation_av'] = groupTotalMeditationHash[reportRow.groupId]['totalMeditation'] / reportRow['members']; 
            // }
            // reportRow['meditation_av'] = formatData('average', reportRow['meditation_av'] );

            reportRow['workout_number_av'] = 0;
            reportRow['workout_number_total'] = 0;
            if (groupTotalWorkoutNumberHash[reportRow.groupId] != undefined) {
                reportRow['workout_number_total'] = groupTotalWorkoutNumberHash[reportRow.groupId]['totalWorkoutNumber'];
                reportRow['workout_number_av'] = groupTotalWorkoutNumberHash[reportRow.groupId]['totalWorkoutNumber'] / reportRow['members'];
            }
            if (reportRow['workout_number_total'] > 0) {
                reportRow['workout_number_av'] = reportRow['workout_number_total'] + ' (' + formatData('average', reportRow['workout_number_av']) + ')';
            }
            else {
                reportRow['workout_number_av'] = '';
            }
            // console.log(reportRow.groupId, reportRow);
        });
        return groupInfoObj;
    }
};
export default bqGetReportChallengeData;
